import type { FaireProductEntity } from "../../entity_types/product";

export const p_ga4qxz2z9f: FaireProductEntity = {
  token: "p_ga4qxz2z9f",
  type: "product",
  name: "Magnesium Complex for Sleep, Relaxation, Digestion & Calm",
  brandToken: "b_52f7r3s9un",
  brandName: "Vitamize inc",
  imageUrl:
    "https://cdn.faire.com/fastly/6a2bcf7ea63f8479cfd7a42b30006fb2b3a05dfd684451f6e4ebe470882cf615.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fd95e0ea7240c8836cab62c591b32ad828d838b1335fb48e189230d1d76089e2.jpeg",
    "https://cdn.faire.com/fastly/a688a952ecb883d403a71746ffbb13b9bb7a0096e7a3fc3b16176c966a1567c3.jpeg",
    "https://cdn.faire.com/fastly/62def990f808b2473197cbe2ca1f4c0a419ee4bc7a0ed434643cec978f4cd669.jpeg",
    "https://cdn.faire.com/fastly/d3bf3b604349c38caf58b0431777f7adbc6b9906c90bd9b0e198ffcf419a5ff3.jpeg",
    "https://cdn.faire.com/fastly/0a070f43ba13c819d36dd2843cffe6ca9cd4ff59993718a1cf970ee88a93a073.jpeg",
    "https://cdn.faire.com/fastly/86e4cd3f1fd2d6883e62102be2545d8a9622d33fc2f31ff4dafff5d843a4876b.jpeg",
    "https://cdn.faire.com/fastly/e8f3566f0ee03dd28859e49ada1e32861802115b9f60f8b5e5b3077d131505f9.jpeg",
    "https://cdn.faire.com/fastly/d19e5fbffdea2d27babf0a4c86a5af7889552cdbfb3d7f3676622e23b9cbae89.jpeg",
  ],
  priceDollars: 12.49,
  description:
    "Sleep Better, Feel Better: Improve the quality of sleep by relaxing the central nervous system that regulates melatonin and GABA. Use Vitamized magnesium for sleep to increase levels of melatonin to support falling asleep faster, staying asleep longer, and waking up feeling more rested.\nTop-grade Magnesium Glycinate Capsules & Maximum Absorption: Our formula combines 7 types of magnesium supplements, including Glycinate, Malate, Taurate, Citrate, Carbonate, Bisglycinate, and Orotate. 450mg of potent magnesium to be relaxed and calm all day!\nHeart Healthy, Bone Density & Muscle Exercise: Studies have shown that magnesium helps regulate vitamins and nutrients like calcium and zinc to support healthy bones and strong bone density. Magnesium can also help support muscles after exercising.*\nHigh Absorption - The only Magnesium complex for women that includes Humic & Monatomic blend to ensure maximum absorption and effectiveness. Our formula is easy on the stomach without any cheap magnesium oxide.\nTrusted Quality and Safety: Made in the USA, our Supplement undergoes rigorous third-party testing to ensure purity, potency, and safety. They're non-GMO, gluten-free, excipient-free, and vegan capsules providing peace of mind for health-conscious consumers.",
  tags: [],
  msrpDollars: 24.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:49.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
